import React, { FC } from 'react';
import { Breadcrumbs as UIBreadcrumbs } from '@prometheus/components';
import { useNavigate } from 'react-router-dom';

import { BreadcrumbsContainer } from './Breadcrumbs.styles';
import { useSelector } from 'react-redux';
import { Breadcrumb } from '@prometheus/types';

export const Breadcrumbs: FC = () => {
  const navigate = useNavigate();
  const breadcrumbs = useSelector(
    (state: any) => state.breadcrumbs.breadcrumbs
  );

  return (
    <>
      <BreadcrumbsContainer>
        <UIBreadcrumbs
          items={breadcrumbs}
          onClick={(item: Breadcrumb) => navigate(item.path)}
        />
      </BreadcrumbsContainer>
    </>
  );
};
